<template>
	<Spin size="large" fix :show="$root.spinShow">
		<Icon type="ios-loading" size=18 style="animation: ani-demo-spin 1s linear infinite;" ></Icon>
		<div>Loading</div>
	</Spin>
	<div class="header" :style="{background: view.titleBackgroud}">
		<div class="header-left" @click="$router.back()">
			<i class="iconfont icon-zuojiantou" v-show="headerLeftStatus"></i>
		</div>
		<div class="header-in">
			{{title}}
		</div>
		<div class="header-right" v-show="headerLeftStatus" @click="$router.push('/home')">
			<Icon type="md-home" />
		</div>
	</div>
</template>

<script>
	import {getToken} from '@/utils/auth'
	import {sysPost} from '@/utils/api'
	export default {
		name: 'titleHead',//head
		props: ['title', 'headerLeftStatus'],
		data() {
			return {
				view:{
					titleBackgroud:''
				}
			}
		},
		mounted() {
			var token = getToken();
			if (token) {
				var backgroud=token.viewTitleBackgroud.split(',');
				this.view.titleBackgroud = "linear-gradient(to right," + backgroud[0] + ", " + backgroud[1] + ")";
			}
			else{
				var that = this;
				sysPost(that, {
					"url": 'Common/SysConfiguration',
					"data": {}
				}, function(result) {
					var backgroud=result.viewTitleBackgroud.split(',');
					that.view.titleBackgroud = "linear-gradient(to right," + backgroud[0] + ", " + backgroud[1] + ")";
				})
			} 
		},
	}
</script>
<style lang="less" scoped>
	.header {
		width: 100%;
		height: 1.05rem;
		position: fixed;
		z-index: 1;
		display: flex;
		color: #ffffff;

		.header-left {
			width: 10%;
			height: 100%;

			i {
				font-size: 0.5rem;
				line-height: 1.05rem;
				text-align: center;
				display: block;
			}
		}

		.header-in {
			width: 80%;
			height: 100%;
			line-height: 1.05rem;
			text-align: center;
			font-size: 0.35rem;
			display: block;
		}

		.header-right {
			width: 10%;
			height: 100%;
			line-height: 1.05rem;
			font-size: 0.4rem;
		}
	}
</style>